import moment from 'moment'

export default function (date, format = 'dddd Do MMM') {
    if (moment(date).format('YYYYMMDD') === moment().format('YYYYMMDD')) {
        return 'Today'
    }

    return moment(date).format(format)
}